module.exports = __webpack_public_path__ + "static/media/icon-open-email.d691c430.svg";